/***
 * @Author: zsh
 * @Date: 2020-02-19 14:28:38
 * @LastEditors: zsh
 * @LastEditTime: 2020-07-10 13:49:38
 * @FilePath: /official-website/src/api/api.js
 **/
"use strict";
// const API = "http://simba.shmtdigital.com/index.php/api"; // 欣巴
// const API = "http://test.simba-sh.com/index.php/api"; // 欣巴测试
// const API = "http://161.117.176.164/index.php/api"; // 正式
const API = "https://www.simba-sh.com/index.php/api"; // 正式

export default {
  // httphost: "http://simba.shmtdigital.com/h5",
  // httphost: "http://test.simba-sh.com/h5",
  // httphost: "http://161.117.176.164/h5",
  httphost: "https://www.simba-sh.com/h5",
  header: API + "/index/header", // 公共头
  home: API + "/index/index", // 首页
  product: API + "/product/index", // 产品中心
  program: API + "/project/index", // 解决方案
  case: API + "/business/index", // 项目案例
  news: API + "/news/index", // 新闻资讯
  aboutus: API + "/aboutus/index", // 关于我们
  submit: API + "/user/index", // 留资

  footer: API + "/index/footer" // 公共底部
};



// WEBPACK FOOTER //
// ./src/api/api.js